import { ReactNode } from 'react'

import { FormProvider, useForm } from 'react-hook-form'

import { IMultipleAutocompleteOption } from 'components/common/controller-wrapper'
import { TimePeriod } from 'components/reports/Metrics/constants/ExceptionMetrics'
import { VehicleTypeFilter } from 'generated/graphql'

export interface ExceptionMetricsFilterValues {
  period: TimePeriod
  customStart: Date | null
  customEnd: Date | null
  selectedServiceCodes: IMultipleAutocompleteOption[]
  vehicleType: VehicleTypeFilter
}

export const EXCEPTION_METRICS_DEFAULT_FILTERS: ExceptionMetricsFilterValues = {
  period: 'last30',
  customStart: null,
  customEnd: null,
  selectedServiceCodes: [],
  vehicleType: VehicleTypeFilter.All,
}

interface IProps {
  children: ReactNode
}

export const ExceptionMetricsFilterCriteria = ({ children }: IProps) => {
  const methods = useForm<ExceptionMetricsFilterValues>({
    defaultValues: EXCEPTION_METRICS_DEFAULT_FILTERS,
  })

  return <FormProvider {...methods}>{children}</FormProvider>
}
